import { logError } from 'fergy-core-react-logging';
import { useEffect, useState } from 'react';
import { FEATURE_FLAGS } from '../../constants/feature-flags';
import { MEDALLIA_EMPLOYEE_FORM_ID, MEDALLIA_SCRIPT_URL } from '../../constants/medallia';
import { useEmployee } from '../apollo/employee/employee.hooks';
import { useFeature } from '../features/features.hooks';
import { useScript } from '../use-script/use-script.hooks';

export const useMedalliaSDK = (callback?: () => void) => {
	const [scriptLoading] = useScript({
		src: MEDALLIA_SCRIPT_URL,
		defer: true
	});
	useEffect(() => {
		if (scriptLoading) {
			return;
		}
		const handleSDKLoad = () => {
			if (callback) {
				callback();
			}
		};

		if (window.KAMPYLE_ONSITE_SDK) {
			handleSDKLoad();
		} else {
			window.addEventListener('neb_OnsiteLoaded', handleSDKLoad);
		}

		return () => {
			window.removeEventListener('neb_OnsiteLoaded', handleSDKLoad);
		};
	}, [scriptLoading]);
};

export const useMedalliaEmployeeForm = () => {
	const { employee } = useEmployee();
	const isInternal = employee.isAuthenticated;
	const employeeFormEnabled = useFeature(FEATURE_FLAGS.MEDALLIA_EMPLOYEE_FORM);

	const loadEmployeeForm = () => {
		if (isInternal && employeeFormEnabled) {
			window.KAMPYLE_ONSITE_SDK.loadForm(MEDALLIA_EMPLOYEE_FORM_ID);
		}
	};

	useMedalliaSDK(loadEmployeeForm);
};

export const useMedallia = (formId: number) => {
	const [isMedalliaLoaded, setIsMedalliaLoaded] = useState(false);

	const openMedalliaForm = () => {
		window.KAMPYLE_ONSITE_SDK.showForm(formId);
	};

	const loadCustomerForm = () => {
		const formLoaded = window.KAMPYLE_ONSITE_SDK.loadForm(formId);
		if (formLoaded) {
			setIsMedalliaLoaded(true);
		} else {
			logError(`Unable to load medallia form ${formId}`);
		}
	};

	useMedalliaSDK(loadCustomerForm);

	return { openMedalliaForm, isMedalliaLoaded };
};
